import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import {
  PANDUAN_PENGELOLAAN_GURU_PENILAIAN_URL,
  PANDUAN_PENGELOLAAN_GURU_SUBSTANSI_PENILAIAN_URL,
  PANDUAN_PENGELOLAAN_GURU_TUTORIAL_PENILAIAN_URL,
} from 'app/KinerjaShared/utils/panduan'

const LIST_PANDUAN: Array<{ icon: string; title: string; link: string }> = [
  {
    icon: 'help',
    title: 'Panduan Substansi Tahap Penilaian Kinerja',
    link: PANDUAN_PENGELOLAAN_GURU_SUBSTANSI_PENILAIAN_URL,
  },
  {
    icon: 'help',
    title: 'Rangkaian tahapan Penilaian Kinerja',
    link: PANDUAN_PENGELOLAAN_GURU_TUTORIAL_PENILAIAN_URL,
  },
  {
    icon: 'help',
    title: 'Artikel tentang rangkaian tahapan Penilaian Kinerja',
    link: PANDUAN_PENGELOLAAN_GURU_PENILAIAN_URL,
  },
]

export default function CardReferensiPenilaian() {
  return (
    <Card className="p-6">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <Text variant="heading-md">Panduan Pendukung</Text>
          <Text color="subdued">
            Bahan bacaan dan video sebagai teman pembimbing mengelola kinerja
            Anda.
          </Text>
        </div>
        <div className="flex gap-4">
          {LIST_PANDUAN.map((item, index) => (
            <Card
              className="w-1/3 border border-subdued"
              key={`panduan_${index}`}
            >
              <div className="p-4 flex gap-4">
                <Icon>{item.icon}</Icon>
                <div className="flex flex-col items-start gap-1">
                  <Text variant="body-bold">{item.title}</Text>
                  <Link href={item.link} passHref>
                    <Button
                      variant="ghost"
                      color="blue"
                      as="a"
                      target="_blank"
                      size="sm"
                      className="!px-1 !py-2"
                      type={undefined}
                    >
                      Selengkapnya
                    </Button>
                  </Link>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </Card>
  )
}
